import {themeColors} from '../../theme/Theme';
import {SaltusAny} from '../../utils/SaltusAny';

/* eslint-disable prettier/prettier */
const styles = (theme: SaltusAny) => ({
  root: {
    position: 'fixed',
    [theme.breakpoints.down('xl')]: {
      position: 'relative',
    },
    top: 0,
    height: '100vh',
    overflow: 'auto',
    backgroundColor: themeColors.backgroundDark,
  },
  gridContainer: {},
  loginBox: {
    position: 'relative',
    display: 'flex !important',
    paddingTop: 100,
    flexDirection: 'column',
    minHeight: '900px !important',
    height: '100vh !important',

    [theme.breakpoints.down('xl')]: {
      paddingTop: 20,
      justifyContent: 'flex-start',
      height: '500px !important',
    },
    boxShadow: '0 0 10px 0 rgba(0,0,0,0.50) !important',
    backgroundColor: themeColors.backgroundMuted,
    '&.signin': {},

    '&.forgotpassword': {
      [theme.breakpoints.down('xl')]: {
        paddingTop: '50px!important',
      },
    },

    '&.resettingpassword': {
      height: '950px!important',

      [theme.breakpoints.down('xl')]: {
        height: '980px!important',
        paddingTop: '50px!important',
      },
      [theme.breakpoints.down('xl')]: {
        height: '1200px!important',
      },
    },

    '&.forgotPasswordStepTwo': {
      height: '950px!important',

      [theme.breakpoints.down('xl')]: {
        height: '980px!important',
        paddingTop: '50px!important',
      },
      [theme.breakpoints.down('xl')]: {
        height: '1200px!important',
      },
    },
  },
  forgotPasswordFooterLG: {
    color: themeColors.tan,
    padding: '0 120px 0 60px',
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
  },
  forgotPasswordFooterXS: {
    display: 'none',
    [theme.breakpoints.down('xl')]: {
      display: 'block',
      color: themeColors.tan,
      marginBottom: 30,
    },
  },
  privacyPolicy: {
    backgroundColor: themeColors.backgroundMuted,
    color: themeColors.tan,
    padding: '30px 120px 30px 60px',
    bottom: 40,
    left: 0,
    zIndex: 0,
    [theme.breakpoints.down('xl')]: {
      paddingRight: 60,
    },

    '& a, & a:active, & a:hover, & a:focus': {
      color: themeColors.tan,
    },
  },
  errorContainer: {
    padding: '0px 60px 0 60px',

    '& div': {
      margin: 0,
    },
  },
  loginGrid: {
    order: 6,
  },
  logoGrid: {
    order: 12,
    [theme.breakpoints.down('xl')]: {
      order: 1,
    },
  },
  logoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100vh',
    padding: '0 0 0 30px',
    [theme.breakpoints.down('xl')]: {
      height: 200,
    },
  },
  StaffLoginButton: {
    background: 'none!important',
    border: 'none',
    padding: '0!important',
    color: themeColors.tan,
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: 1.43,
  },
  version: {
    color: themeColors.tanMuted,
  },
});

export default styles;
